module.exports = __webpack_public_path__ + "img/login-logo.96b89bbc.png";